import React, {Component} from 'react'
import {Button, FormGroup} from 'reactstrap'
import {AvForm} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'

import PermissionsList from '../permissions/PermissionsCheckboxList'
import upsertUserPermissionsMutation from '../../../queries/server/mutations/upsert_user_permissions'
import localMutation from '../../../queries/client_side/mutations/edit_user'
import {toast} from "react-toastify";

export default class UserPermissionsForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props
        }
    }

    selectAll = (permissions) => {
        this.setState({user: {...this.state.user, permissions}})
    }

    render() {

        const {user: {permissions}} = this.state
        const {user} = this.props

        return (
            <Mutation mutation={localMutation}>
                {(localMutationFunc) => (
                    <Mutation mutation={upsertUserPermissionsMutation}>
                        {(upsertUserPermissionsMutationFunc, {loading}) => (
                            <AvForm
                                onValidSubmit={() => {
                                    upsertUserPermissionsMutationFunc({
                                        variables: {
                                            user_id: user.user_id,
                                            permissions: permissions.map(({permission_id, access}) => ({
                                                permission_id,
                                                access
                                            }))
                                        }
                                    })
                                        .then(({data}) => {
                                            localMutationFunc({variables: {data: data.upsertUserPermissions}})
                                            toast.success('User Permissions Updated', {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <FormGroup check>
                                    <PermissionsList
                                        selectedPermissions={permissions}
                                        onSelectAll={this.selectAll}
                                        onChange={(permission_id, access) => {

                                            const newData = {permission_id, access}

                                            const index = permissions.findIndex(p => p.permission_id === permission_id)

                                            let newPermissions = []

                                            if (index === -1) {
                                                newPermissions.push(newData)
                                            }
                                            else {
                                                newPermissions = [
                                                    ...permissions.slice(0, index),
                                                    {permission_id, access},
                                                    ...permissions.slice(index + 1)
                                                ]
                                            }
                                            this.setState({user: {...this.state.user, permissions: newPermissions}})

                                        }}
                                    />
                                </FormGroup>
                                <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                                    <Button
                                        size="sm"
                                        color="success"
                                        disabled={loading}

                                    >
                                        <FontAwesomeIcon
                                            color="#fff"
                                            icon={loading ? 'spinner' : 'save'}
                                            spin={loading}
                                        />{' '}
                                        {loading ? 'Saving...' : 'Save User Permissions'}
                                    </Button>
                                </div>
                            </AvForm>
                        )}

                    </Mutation>
                )}

            </Mutation>
        )

    }

}

UserPermissionsForm.propTypes = {
    user: PropTypes.object.isRequired,
}